import { makeStyles, tokens } from '@fluentui/react-components';

export const useBidStrategyCardStyles = makeStyles({
  container: {
    '& .error': {
      color: tokens.colorPaletteCranberryBorderActive,
    },
  },
});
